module.exports = __webpack_public_path__ + "img/section4Logo4.6dfd4ed6.svg";